import { AppConfig } from './../../app.config';
import { Input, Injectable } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { InvestmentPlan, initialInvestmentPlan, Product, investmentPlanPeriodTypes } from 'src/app/models/orders';
import { TradingFacades } from 'src/app/store/order/facades/trading.facades';


@Injectable({ providedIn: 'root' })
export class RegularInvestmentPlanService {
    private products$: Observable<Product[]>;
    private investmentPlan$: Observable<Partial<InvestmentPlan>>;
    constructor(private tradingFacade: TradingFacades) { }

    /**
     * Ensures the positions of the given investment plan sums to 100%. If they do not
     * the first position is adjusted accordingly to make up the difference.
     * If the investment plan has not been initialised it returns the default plan.
     */
    public checkRegularInvestmentPlanPercentage(investmentPlan: InvestmentPlan): InvestmentPlan {
        let accumulatedPercentage = 0;
        const positions = [];
        if (investmentPlan && investmentPlan.positions && investmentPlan.positions.length) {
            investmentPlan.positions.forEach(position => {
                positions.push({
                    ...position,
                    percent: Number(position.percent.toFixed(6))
                });
            });

            investmentPlan = {
                ...investmentPlan,
                positions: positions
            };

            investmentPlan.positions.forEach(x => {
                accumulatedPercentage += x.percent;
            });

            if (investmentPlan.positions.length > 0) {
                if (accumulatedPercentage !== 1) {
                    let oldPercent = investmentPlan.positions[0].percent;

                    let position = investmentPlan.positions[0];

                    position = {
                        ...position,
                        percent: Number((oldPercent += (1 - accumulatedPercentage)).toFixed(6))
                    };

                    investmentPlan = {
                        ...investmentPlan,
                        positions: investmentPlan.positions.filter(x => x.securityId !== position.securityId),
                    };
                    investmentPlan.positions.push(position);
                }
            }
            return investmentPlan;
        } else {
            return initialInvestmentPlan;
        }
    }

    private getPlansAndProducts$() {
        this.products$ = this.tradingFacade.getProducts().pipe(
            filter((products) => products != null),
            map((products) => {
                return products;
            })
        );

        this.investmentPlan$ = this.tradingFacade.getRegularInvestmentPlan().pipe(
            filter((ip) => ip != null),
            map((ip) => {
                return ip;
            })
        );

        return combineLatest([
            this.products$,
            this.investmentPlan$]);
    }

    public loadProductAndPlanDetails$() {
        return this.getPlansAndProducts$().pipe(
            map((values: [Product[], InvestmentPlan]) => {
                return values;
        }));
    }
}
